var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import styled, { css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { TextButton } from '@finect/tabular-core/TextButton';
var verticalStyles = css([":not(:first-child){padding-top:24px;}"]);
var horizontalStyle = css(["padding:6px 9px;border-radius:", ";box-shadow:", " 0 0 0 2px;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiL;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiLL;
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-27fcim-0"
})(["display:flex;", " ", ";"], function (_ref4) {
  var layout = _ref4.layout;
  return ['vertical'].includes(layout) ? verticalStyles : horizontalStyle;
}, maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))));
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-27fcim-1"
})(["h4{font-weight:700;}"]);
export var IconContent = styled.div.withConfig({
  displayName: "partials__IconContent",
  componentId: "sc-27fcim-2"
})(["display:flex;align-items:center;justify-content:center;border-radius:4px;margin-right:12px;"]);
export var Button = styled(TextButton).withConfig({
  displayName: "partials__Button",
  componentId: "sc-27fcim-3"
})(["font-weight:500;", ""], getFont(-1, 'compact'));